import React from "react";
import { useDirectMessageContext } from "@/context/DirectMessageContext";
import DirectMessagePopup from "./DirectMessagePopup";

const DirectMessageContainer: React.FC = () => {
  const { openChats } = useDirectMessageContext();

  if (openChats.length === 0) return null;

  return (
    <>
      {openChats.map((chat, index) => (
        <DirectMessagePopup
          key={chat.userId}
          userId={chat.userId}
          userName={chat.userName}
          avatarUrl={chat.avatarUrl}
          style={{ right: `${260 + index * 490}px` }}
        />
      ))}
    </>
  );
};

export default DirectMessageContainer;
